exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hide{\n display:none;\n}\n\n.login_popup {width:300px;}\n.mat-form-field{width:100%;}\n.login_popup input, .mat-form-field-placeholder-wrapper{font-size: 14px;}\n\n.mat-error.error_text{bottom:-15px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/home/login/login.component.css
// module id = ../../../../../src/app/home/login/login.component.css
// module chunks = 39